import { ACTIVE_USERS_API } from "../../../constants/api";
import axiosHttp from "../../interceptors/axios-interceptor";

export default function GetActiveUsersCount(){
    const api = `${ACTIVE_USERS_API}count/`;
    return axiosHttp.get(api);
}